import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";

export class MapUtils {
    constructor() {}

    /**
     * Berechnet den Minimalen Extent
     *
     * @param {geometries} __esri.Geometry | __esri.Geometry[] - Einzelne Geometry oder Array mit Geometrien
     * @returns {Extent} Minimaler Extent
     */
    static calculateMinExtent(geometries: __esri.Geometry | __esri.Geometry[]): __esri.Extent {
        const geometry = Array.isArray(geometries)? geometryEngine.union(geometries): geometries;
        let extent = geometry.extent;
        // Extent mit mindestens 50x50 Meter sicherstellen
        // TODO: In config verschieben
        if (!extent) {
            const buffer = geometryEngine.buffer(geometry, 25, "meters");
            if(Array.isArray(buffer)) {
                extent = buffer[0].extent;
            } else if (buffer.extent) {
                extent = buffer.extent;
            }
        }else if(extent.width < 50 || extent.height < 50) {
            if(extent.width < 50){
                const xPadding = Math.ceil((50 - extent.width)/2);
                extent.xmin-=xPadding;
                extent.xmax+=xPadding;
            }
            if(extent.height < 50){
                const yPadding = Math.ceil((50 - extent.height)/2);
                extent.ymin-=yPadding;
                extent.ymax+=yPadding;
            }
        }
        return extent;
    }

}

